// extracted by mini-css-extract-plugin
export var actions = "_ml-g";
export var benefitCard = "_ml-b";
export var benefitIcon = "_ml-d";
export var benefitLabel = "_ml-f";
export var benefits = "_ml-a";
export var benefitsSection = "_ml-8";
export var bodyText = "_ml-7";
export var closeButton = "_ml-2";
export var content = "_ml-3";
export var eyebrow = "_ml-4";
export var heading = "_ml-5";
export var image = "_ml-i";
export var imagePanel = "_ml-h";
export var modal = "_ml-0";
export var offerCard = "_ml-c";
export var offerIcon = "_ml-e";
export var sectionLabel = "_ml-9";
export var shell = "_ml-1";
export var title = "_ml-6";